import styled from "styled-components";

export default styled.hr`
    border-top: 0;
    border: 1px solid #535353;
    margin: 2px;
`;